import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal, Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import Select from "react-select";
import Pagination from "react-js-pagination";
import { openPrivateSessionUserModal } from "ContentActions";
import {
  sortUserByCategory,
  searchUserByCategoryAndText,
  sortUserByCategoryExceptAdmin, //For Manage Users in community
  searchUserByCategoryAndTextExceptAdmin, //For Manage Users in community
} from "DashboardUserAction";
import NoContent, { NO_USER } from "NoContent";
import { itemCount } from "Constants";
import UsersCell from "./userscell";
import LocaleStrings from "Languages";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class SessionPrivateUserModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      search: "",
      allCheck: false,
      selectedCategory: "",
      categotyValue: {},
      selectedUsers: [],
      selectedCategoryAllUsers: [],
      selectedCategorySelectedUsers: [],
    };
  }

  componentDidMount() {
    /* Fetch users from communitiy member table with status 'requested' [Requested Users list] */

    const { userCategoryList, flag, totalUsersList } = this.props;

    let selectedUserCategory = _.filter(userCategoryList.data, (obj) => {
      if (flag == "GAMIFICATION") return obj.type === "admin";
      else return obj.type === "attendee";
      // return obj.type === (flag === "COMMUNITY" ? "attendee" : "admin");
    });

    this.setState({
      selectedUsers: this.props.membersData,
      selectedCategory: selectedUserCategory[0].id,
      categotyValue: {
        value: selectedUserCategory[0].id,
        label: selectedUserCategory[0].groupname,
      },
    });

    setTimeout(() => {
      this.checkMatchArray(this.props.membersData);
    }, 500);
  }

  closePrivateUserModal = () => {
    this.props.openPrivateSessionUserModal({ show: false });
  };

  handleCategoryChange = (e) => {
    var cat = e.value;
    var pageNumber = 1;

    this.setState({
      selectedCategory: cat,
      categotyValue: e,
      pageNumber,
    });

    setTimeout(() => {
      this.paginationCallback(pageNumber);
    }, 500);
  };

  onSearchUser = (event) => {
    var search = event.target.value;
    var pageNumber = 1;

    this.setState({ search, pageNumber });

    setTimeout(() => {
      this.paginationCallback(pageNumber);
    }, 500);
  };

  // Single single add or remove user
  selectionCallback = (user) => {
    var { selectedUsers } = this.state;
    var index = _.findIndex(selectedUsers, function (curuser) {
      return curuser.appuserid === user.appuserid;
    });
    if (index >= 0) {
      var newSelectedUsers = _.filter(selectedUsers, function (selusers) {
        return selusers.appuserid !== user.appuserid;
      });
      this.checkMatchArray(newSelectedUsers);
      this.setState({ selectedUsers: newSelectedUsers });
    } else {
      var selectedUser = { ...user, checked: true };
      selectedUsers = [...selectedUsers, selectedUser];
      this.checkMatchArray(selectedUsers);
      this.setState({ selectedUsers });
    }
  };

  // Here we are checking to user who are visiable on screen only
  selectAllUsers = () => {
    var state = this.state.allCheck;
    var { selectedUsers } = this.state;
    let { flag } = this.props;

    var allUsers = this.props.userList.data;
    var newSelectUser = [];
    var newSelectedUsers = [];

    if (state == false) {
      // SELECT ALL
      _.map(allUsers, (user) => {
        var checkUserExitOrNot = _.filter(selectedUsers, function (selusers) {
          return selusers.appuserid === user.appuserid;
        });

        //Check if user is not exist in selected user that add
        if (checkUserExitOrNot.length == 0) {
          newSelectUser = { ...user, checked: true };
          selectedUsers = [...selectedUsers, newSelectUser];
        } else {
          // Community part
          if (flag === "COMMUNITY") {
            newSelectUser = {
              ...user,
              checked: true,
              status: checkUserExitOrNot[0].status,
            };
          }
        }
        this.checkMatchArray(selectedUsers);
        this.setState({ selectedUsers });
      });
    } else {
      // DESELECT ALL
      var leftUsers = selectedUsers;

      _.map(allUsers, (user) => {
        newSelectedUsers = _.filter(leftUsers, function (selusers) {
          if (flag === "COMMUNITY" && selusers.status) {
            return true;
          } else {
            return selusers.appuserid !== user.appuserid;
          }
        });

        leftUsers = newSelectedUsers;

        this.checkMatchArray(leftUsers);
        this.setState({ selectedUsers: leftUsers });
      });
    }
  };

  // Here we are checking all thes users of selected category
  handleSelectAllUsers = () => {
    let {
      selectedCategory,
      selectedUsers,
      selectedCategoryAllUsers,
      selectedCategorySelectedUsers,
    } = this.state;
    let allUsers = selectedCategoryAllUsers;
    var newSelectedUsers = [];
    // console.log("selectedCategory :- ", selectedCategory);
    // console.log("allUsers ----------:- ", allUsers);
    // console.log("selectedUsers ----------:- ", selectedUsers);

    if (
      selectedCategoryAllUsers.length === selectedCategorySelectedUsers.length
    ) {
      newSelectedUsers = _.filter(selectedUsers, (o) => {
        return o.usercategory.search(selectedCategory) < 0;
      });

      // console.log("after clear :- ", newSelectedUsers);

      this.checkMatchArray(newSelectedUsers);
      this.setState({ selectedUsers: newSelectedUsers });
    } else {
      let afterClearNewSelectedUsers = _.filter(selectedUsers, (o) => {
        return o.usercategory.search(selectedCategory) < 0;
      });
      // console.log("afterClearNewSelectedUsers :- ", afterClearNewSelectedUsers);

      let selectNew = allUsers.map((v) => ({ ...v, checked: true }));

      newSelectedUsers = afterClearNewSelectedUsers.concat(selectNew);

      // console.log("after adding :- ", newSelectedUsers);

      this.checkMatchArray(newSelectedUsers);
      this.setState({ selectedUsers: newSelectedUsers });
    }
  };

  paginationCallback = (pageNumber) => {
    let { search, selectedCategory, selectedUsers } = this.state;
    let { flag } = this.props;

    if (search == "") {
      if (flag === "COMMUNITY") {
        // When Its call from community Module
        this.props.sortUserByCategoryExceptAdmin(
          this.props.appsession,
          selectedCategory,
          pageNumber,
          0,
          (response) => {
            this.checkMatchArray(selectedUsers);
          }
        );
      } else {
        // When Its call from session Module
        this.props.sortUserByCategory(
          this.props.appsession,
          selectedCategory,
          pageNumber,
          0,
          (response) => {
            this.checkMatchArray(selectedUsers);
          }
        );
      }
    } else {
      if (flag === "COMMUNITY") {
        // When Its call from community Module
        this.props.searchUserByCategoryAndTextExceptAdmin(
          this.props.appsession,
          selectedCategory,
          search,
          pageNumber,
          0,
          (response) => {
            this.checkMatchArray(selectedUsers);
          }
        );
      } else {
        // When Its call from session Module
        this.props.searchUserByCategoryAndText(
          this.props.appsession,
          selectedCategory,
          search,
          pageNumber,
          0,
          (response) => {
            this.checkMatchArray(selectedUsers);
          }
        );
      }
    }
    this.setState({ ...this.state, pageNumber });
  };

  // This function is used to check or uncheck master check field
  checkMatchArray = (selectedUsers) => {
    setTimeout(() => {
      let { totalUsersList } = this.props;
      let { selectedCategory, search } = this.state;
      var userList = this.props.userList.data;

      var newArray = [];
      _.map(userList, (appUser) => {
        var newSelectedUsers = _.filter(selectedUsers, function (selusers) {
          return selusers.appuserid === appUser.appuserid;
        });

        // New
        if (newSelectedUsers && newSelectedUsers.length > 0) {
          // newArray = [...newArray, newSelectedUsers];
          newArray.push(newSelectedUsers[0]);
        }
      });

      // Check for all user selected or not according to that check or uncheck master check option
      if (newArray.length > 0 && newArray.length === userList.length) {
        this.setState({ allCheck: true });
      } else {
        this.setState({ allCheck: false });
      }

      // console.log("---------------------------------------------------");
      // console.log("selectedCategory--------------", selectedCategory);
      // console.log("search--------------", search);
      // console.log("selectedUsers--------------", selectedUsers);
      // console.log("totalUsersList--------------", totalUsersList);
      // console.log("---------------------------------------------------");

      // Get selected category all users
      let selCategoryAllUsers = [];
      if (totalUsersList.resource) {
        if (search === "") {
          selCategoryAllUsers = _.filter(totalUsersList.resource, (o) => {
            return o.usercategory.search(selectedCategory) >= 0;
          });
        } else {
          selCategoryAllUsers = _.filter(totalUsersList.resource, (o) => {
            return (
              o.usercategory.search(selectedCategory) >= 0 &&
              (o.username.toLowerCase().search(search) >= 0 ||
                o.email.toLowerCase().search(search) >= 0)
            );
          });
        }
      }

      // Get selected category all selected users
      let selCategorySelUsers = _.filter(selectedUsers, (o) => {
        return o.usercategory.search(selectedCategory) >= 0;
      });

      this.setState({
        selectedCategoryAllUsers: selCategoryAllUsers,
        selectedCategorySelectedUsers: selCategorySelUsers,
      });
    }, 100);
  };

  /* When User change the status of community member from "Selected Users List" */
  statusChangeCallback = (user, status) => {
    let { selectedUsers } = this.state;
    var index = _.findIndex(selectedUsers, function (curuser) {
      return curuser.appuserid === user.appuserid;
    });
    // selectedUsers[index].

    selectedUsers[index].status = status;
    this.checkMatchArray(selectedUsers);
    this.setState({ selectedUsers });
  };

  // Function to update private user by selecting them to save in db on final save button click from newsession.js file.
  updateAssociatedUsers = () => {
    var { selectedUsers } = this.state;
    this.props.updateAccoicatedUsers(selectedUsers);
    this.props.openPrivateSessionUserModal({ show: false });
  };

  /* Users List [Left side]*/
  renderUserList() {
    var { selectedUsers } = this.state;

    var users = this.props.userList.data;
    var cells = [];

    _.map(users, (appUser, index) => {
      var selected = selectedUsers.find(
        (curuser) => curuser.appuserid === appUser.appuserid
      );

      var checked = false;
      var isDisabled = false;
      if (selected) {
        checked = selected.checked;
        if (selected.status) {
          isDisabled = true;
        }
      }

      cells.push(
        <UsersCell
          key={appUser.appuserid}
          user={appUser}
          checked={checked}
          isDisabled={isDisabled}
          selectedusers={false}
          toggleSelection={this.selectionCallback}
          statusChangeselected={this.statusChangeCallback}
          flag={this.props.flag}
        />
      );
    });
    return cells;
  }

  renderSelectedUserList() {
    var { selectedUsers } = this.state;
    var cells = [];

    _.map(selectedUsers, (appUser, index) => {
      var checked = false;
      let isDisabled = true;
      cells.push(
        <UsersCell
          key={`selected_${index}`}
          user={appUser}
          checked={checked}
          isDisabled={appUser.status ? isDisabled : false}
          selectedusers={true}
          removeFromSelected={this.selectionCallback}
          statusChangeselected={this.statusChangeCallback}
          flag={this.props.flag}
        />
      );
    });
    return cells;
  }

  render() {
    const { userCategoryList, userList, flag } = this.props,
      {
        categotyValue,
        selectedUsers,
        selectedCategoryAllUsers,
        selectedCategorySelectedUsers,
      } = this.state;
    var categories = [];
    var allListLeft = { borderRight: "1px solid #e6edf3" };
    var allListRight = {};

    let acceptedCount = "";
    if (selectedUsers.length > 0) {
      let x = _.filter(selectedUsers, function (o) {
        return o.status === "accepted";
      });

      acceptedCount = x.length;
    }

    _.map(userCategoryList.data, (item, index) => {
      // if (item.type !== "admin" && flag !== "GAMIFICATION") {
      //   // allowiing admin category for gamification point assigning
      //   categories.push({ value: item.id.toString(), label: item.groupname });
      // } else
      //   categories.push({ value: item.id.toString(), label: item.groupname });

      if (flag === "GAMIFICATION") {
        categories.push({ value: item.id.toString(), label: item.groupname });
      } else {
        if (item.type !== "admin") {
          categories.push({ value: item.id.toString(), label: item.groupname });
        }
      }
    });

    if (
      userList.data.length < 11 &&
      selectedUsers.length > userList.data.length
    ) {
      var allListLeft = {};
      var allListRight = { borderLeft: "1px solid #e6edf3" };
    }

    // console.log("selectedUsers :----- ", selectedUsers);
    // console.log("selectedCategoryAllUsers :------ ", selectedCategoryAllUsers);
    // console.log(
    //   "selectedCategorySelectedUsers :----- ",
    //   selectedCategorySelectedUsers
    // );

    return (
      <Modal
        className="modal-container"
        show={this.props.sessionPrivateUsersModal.show === true ? true : false}
        onHide={this.closePrivateUserModal}
        animation={true}
        keyboard={false}
        backdrop="static"
        dialogClassName="associateUserModal"
        enforceFocus={false}
      >
        <Modal.Header className="h-100px">
          <Container>
            {" "}
            <Row>
              <Col sm={5}>
                {" "}
                <Select
                  name="userCategory"
                  value={categotyValue}
                  options={categories}
                  onChange={this.handleCategoryChange}
                  isSearchable={false}
                  className="border border-black"
                />
                {/* --- Allowing admins to get selected for ganification extra points assigning --- */}
                {flag !== "GAMIFICATION" ? (
                  <>
                    <span className="text-danger">
                      *Admins are added by default
                    </span>
                  </>
                ) : (
                  ""
                )}
              </Col>
              <Col sm={5}>
                <input
                  className="form-control private-user-search"
                  placeholder={
                    LocaleStrings.content_community_search_box_placeholder
                  }
                  // type="search"
                  type="text"
                  value={this.state.search}
                  onChange={this.onSearchUser}
                />
              </Col>
              <Col sm={2}>
                <button
                  type="button"
                  className="i-custom-cross-popup -mt-minus44 pull-right"
                  onClick={() => this.closePrivateUserModal()}
                >
                  <img
                    className="i-custom-small"
                    src="../../style/images/custom-icons/cross-black.png"
                  />
                </button>
              </Col>
            </Row>
          </Container>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div
              className={classNames(
                flag === "COMMUNITY" ? "col-md-4" : "col-md-6",
                ""
              )}
              style={allListLeft}
            >
              <h3>{LocaleStrings.content_community_users_list_table_header}</h3>
              {userList.data && userList.count > 0 ? (
                <table className="table">
                  <thead>
                    <tr>
                      <th style={{ padding: 8 }}>
                        <div className="vertical-align-center">
                          <label className="custom-container-checkbox">
                            <input
                              type="checkbox"
                              onChange={this.selectAllUsers}
                              checked={this.state.allCheck}
                            />
                            <span className="checkmark" />
                          </label>
                          <div>{LocaleStrings.schedule_label_name}</div>

                          {selectedUsers.length > 0 ? (
                            <div className="ml-10">
                              <span
                                className="text-primary cursor-pointer"
                                onClick={this.handleSelectAllUsers}
                              >
                                {selectedCategoryAllUsers.length ===
                                selectedCategorySelectedUsers.length
                                  ? LocaleStrings.clear_all_selected_category_users
                                  : _.replace(
                                      LocaleStrings.select_all_selected_category_users,
                                      "#total",
                                      userList.count
                                    )}
                              </span>
                            </div>
                          ) : null}
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>{this.renderUserList()}</tbody>
                </table>
              ) : (
                <NoContent contentType={NO_USER} />
              )}

              {this.props.userList.data &&
              this.props.userList.count > itemCount ? (
                <Pagination
                  activePage={this.state.pageNumber}
                  itemsCountPerPage={itemCount}
                  totalItemsCount={this.props.userList.count}
                  pageRangeDisplayed={5}
                  onChange={this.paginationCallback}
                />
              ) : null}
            </div>
            {/* Only Show When Call From Community */}

            <div
              className={classNames(
                flag === "COMMUNITY" ? "col-md-8" : "col-md-6",
                ""
              )}
              style={allListRight}
            >
              <div>
                <h3>
                  {LocaleStrings.content_community_selected_users_table_header}
                </h3>
              </div>
              {selectedUsers.length > 0 ? (
                <table className="table scrollable-table">
                  <thead>
                    <tr>
                      <th style={{ padding: 8, width: "100%" }}>
                        <div className="vertical-align-center-justify-between">
                          <div>{LocaleStrings.schedule_label_name}</div>

                          <div className="pull-right">
                            {flag === "COMMUNITY"
                              ? LocaleStrings.content_community_total_members +
                                " " +
                                acceptedCount
                              : LocaleStrings.schedule_total +
                                " " +
                                selectedUsers.length}
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="scroll-section">
                    {this.renderSelectedUserList()}
                  </tbody>
                </table>
              ) : (
                <NoContent contentType={NO_USER} />
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-custom-blue"
            onClick={this.updateAssociatedUsers}
          >
            {LocaleStrings.content_community_users_update_button}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    appsession: state.session,
    session: state.sessionModal.session,
    showModal: state.sessionModal.status,
    sessionPrivateUsersModal: state.sessionPrivateUsersModal,
    userCategoryList: state.userCategoryList,
    userList: state.dashboardUserList,
    requestedCommunityMemberList: state.requestedCommunityMemberList,
    totalUsersList: state.dashboardTotalUsers,
    flag: ownProps.flag, // SESSION, COMMUNITY, GAMIFICATION
  };
}

export default connect(mapStateToProps, {
  openPrivateSessionUserModal,
  sortUserByCategory,
  searchUserByCategoryAndText,
  sortUserByCategoryExceptAdmin,
  searchUserByCategoryAndTextExceptAdmin,
})(SessionPrivateUserModal);
